/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdiscardconfirm2Inputs */

const en_dropdiscardconfirm2 = /** @type {(inputs: Dropdiscardconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const de_dropdiscardconfirm2 = /** @type {(inputs: Dropdiscardconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Dropdiscardconfirm2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdiscardconfirm2 = /** @type {((inputs?: Dropdiscardconfirm2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdiscardconfirm2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdiscardconfirm2(inputs)
	return de_dropdiscardconfirm2(inputs)
});
export { dropdiscardconfirm2 as "dropDiscardConfirm" }